var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12531",
    "data-name": "Group 12531",
    transform: "translate(-326 -144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-eye",
    transform: "translate(326 139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14306",
    "data-name": "Path 14306",
    d: "M29,14a1,1,0,1,0,1,1A1,1,0,0,0,29,14ZM1,14a1,1,0,1,0,1,1,1,1,0,0,0-1-1Zm14-2a3,3,0,1,0,3,3A3,3,0,0,0,15,12Z",
    fill: "#401bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14307",
    "data-name": "Path 14307",
    d: "M29.8,14.408S24,5,15,5,.2,14.408.2,14.408L.163,15.544S5,25,15,25s14.838-9.456,14.838-9.456ZM15,22a7,7,0,1,1,7-7A7,7,0,0,1,15,22Z",
    fill: "#401bfa"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(341 155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14308",
    "data-name": "Path 14308",
    d: "M22.2,20.8A5.376,5.376,0,0,0,23,18a5,5,0,1,0-5,5,5.376,5.376,0,0,0,2.8-.8L22.6,24,24,22.6ZM18,21a3,3,0,1,1,3-3A2.946,2.946,0,0,1,18,21Z",
    transform: "translate(331 145)",
    fill: "#401bfa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.9afab89067f98e72372dbecf2873dae5.svg";
export { ForwardRef as ReactComponent };